import React from "react";
import { Delete } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import { Box, IconButton, Paper, Tooltip, Typography } from "@material-ui/core";
export var TrackEntry = function (_a) {
    var index = _a.index, track = _a.track, onRemove = _a.onRemove;
    var title = (track === null || track === void 0 ? void 0 : track.type) === "private" ? "Загруженный файл" : "Трек";
    var remove = function () { return onRemove(index); };
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Box, { display: "flex", justifyContent: "space-between" },
            React.createElement(Typography, { variant: "h6" }, title),
            React.createElement(Tooltip, { title: "Удалить" },
                React.createElement(IconButton, { size: "small", onClick: remove },
                    React.createElement(Delete, { htmlColor: red[700] })))),
        React.createElement(Box, { mt: 2, display: "flex", flexDirection: "column" },
            React.createElement(Typography, { variant: "subtitle2" },
                "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435: ", track === null || track === void 0 ? void 0 :
                track.title),
            React.createElement(Typography, { variant: "subtitle2" },
                "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C: ", track === null || track === void 0 ? void 0 :
                track.duration.formatted))));
};
